var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1514_26504)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6931 31.4139L54.7229 37.755L45.4194 43.1705V54.0279L40.0166 57.1689L34.6138 54.0279V43.1705L25.3102 37.755V31.4139L30.7362 28.2433L39.9835 33.6851L49.287 28.2433L54.7163 31.4139H54.6931ZM25.3069 20.5861L39.9868 12L54.6931 20.5861L49.2903 23.7566L39.9868 18.3148L30.7097 23.7566L25.3069 20.5861ZM21.4028 40L21.4326 50.8311L30.7096 56.2466V62.5877L16.0033 54.0312V36.8327L21.4028 40ZM21.4028 29.1689V35.4805L16 32.3099V25.9984L21.4028 22.8278L26.8321 25.9984L21.4028 29.1689ZM34.5839 25.9984L39.9867 22.8278L45.416 25.9984L39.9867 29.1689L34.5839 25.9984ZM25.3069 42.245L30.7097 45.4155V51.7271L25.3069 48.5861V42.245ZM34.584 58.5179L39.9868 61.6884L45.4161 58.5179V64.8294L39.9868 68L34.584 64.8294V58.5179ZM53.1646 25.9984L58.5674 22.8278L63.9967 25.9984V32.3099L58.5674 35.4805V29.1689L53.1646 25.9984ZM58.5972 40L64 36.8295V54.0279L49.2937 62.5845V56.2434L58.5674 50.8311L58.5972 40ZM49.2903 51.7271L54.6931 48.5861V42.245L49.2903 45.4155V51.7271Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1514_26504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.776c9c6edab31fc134b406d605a0aec4.svg";
export { ForwardRef as ReactComponent };